<template>
  <k-dialog>
    <div class="dialog-wrapper dialog-readtip-wrapper">
      <div class="no-box">
        <img :src="require('@/assets/imgs/answer/error.png')" />
        <p>仔细在游戏介绍中找到答案再试一次吧</p>
      </div>
      <button class="dialog-btn-submit" @click="onClose">我知道了</button>
    </div>
  </k-dialog>
</template>
<script>
import KDialog from '@com/base/Dialog';
export default {
  name: 'AnswerError',
  components: {
    KDialog
  },
  methods: {
    onClose() {
      this.$store.commit('CLOSE_DIALOG', 'AnswerError');
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-readtip-wrapper {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 501;
  .no-box {
    img {
      display: block;
      width: 100%;
    }
    p {
      color: #333;
      font-size: 24px;
      margin: 20px auto 0;
      line-height: 35px;
      span {
        color: #ffc341;
        font-weight: bold;
      }
    }
  }
}
</style>
